<div class="central-container">
  <div class="modal-container">
    <ng-container *ngTemplateOutlet="templateRef"></ng-container>
  </div>
</div>